import SendedMessage from "./SendedMessage";

export default SendedMessage